/**
 * Converte texto de template em HTML com formatação ABNT
 * Quebras duplas (\n\n) viram novos parágrafos <p>
 * Linhas vazias são preservadas
 * Primeira linha vira título se estiver em MAIÚSCULAS
 */
export function convertTemplateToHtml(templateText: string): string {
  if (!templateText) return '<p></p>';
  
  // Dividir por quebras duplas (parágrafos)
  const lines = templateText.split('\n\n');
  
  let html = '';
  
  lines.forEach((line, index) => {
    const trimmed = line.trim();
    
    // Pular linhas vazias
    if (!trimmed) return;
    
    // Primeira linha em MAIÚSCULAS vira H1
    if (index === 0 && trimmed === trimmed.toUpperCase() && trimmed.length > 3) {
      html += `<h1>${trimmed}</h1>\n`;
    } 
    // Outras linhas viram parágrafos
    else {
      // Substituir quebras simples dentro do parágrafo por espaços
      const paragraph = trimmed.replace(/\n/g, ' ');
      html += `<p>${paragraph}</p>\n`;
    }
  });
  
  return html;
}
